const ProductInfo = () => import(/* webpackChunkName: "product" */ '@/modules/product/views/ProductInfo')
const ProductPreviewForSupplier = () => import(/* webpackChunkName: "product" */ '@/modules/product/views/ProductPreviewForSupplier')
const Search = () => import(/* webpackChunkName: "product" */ '@/modules/product/views/Search')

export default [
  {
    path: '/products/:id',
    name: 'ProductInfo',
    component: ProductInfo
  },
  {
    path: '/products/:id/preview',
    name: 'ProductPreviewForSupplier',
    component: ProductPreviewForSupplier
  },
  {
    path: '/:slug/id/:id',
    name: 'ProductInfoWithSLug',
    component: ProductInfo
  },
  {
    path: '/search',
    name: 'Search',
    component: Search
  }
]
